import React, { useState } from 'react';
import { Link } from "react-router-dom";

//lightbox
// import Lightbox from 'react-image-lightbox';
import config from "../../config";
// import 'react-image-lightbox/style.css';

const ImageList = props => {
    const [isOpen, setisOpen] = useState(false)
    const [currentImage, setcurrentImage] = useState(null)
    const [images] = useState(props.images)

    const toggleLightbox = (currentImage) => {
        setisOpen(!isOpen)
        setcurrentImage(currentImage)
    }

    return (
        <React.Fragment>
            <ul className="list-inline mb-0">
                {/* image list */}
                {
                    images.map((imgMsg, key) =>
                        <li key={key} className="list-inline-item message-img-list">
                            <div>
                                <Link to="#" onClick={() => toggleLightbox(config.CHAT_URL + imgMsg.image_url)} className="popup-img d-inline-block m-1" title={imgMsg.title}>
                                    <img src={config.CHAT_URL + imgMsg.image_url} alt={imgMsg.title} className="rounded border" />
                                </Link>
                            </div>
                            { imgMsg.description && 
                            <div className='message-img' style={{padding: '10px'}}>
                                {imgMsg.description}
                            </div>}
                            {/* <div className="message-img-link">
                                <ul className="list-inline mb-0">
                                   <li className="list-inline-item">
                                        <Link to="#">
                                            <i className="ri-download-2-fill"></i>
                                        </Link>
                                    </li>
                                    <UncontrolledDropdown tag="li" className="list-inline-item">
                                        <DropdownToggle tag="a">
                                            <i className="ri-more-fill"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem>{t('Copy')} <i className="ri-file-copy-line float-end text-muted"></i></DropdownItem>
                                            <DropdownItem>{t('Save')} <i className="ri-save-line float-end text-muted"></i></DropdownItem>
                                            <DropdownItem>{t('Forward')} <i className="ri-chat-forward-line float-end text-muted"></i></DropdownItem>
                                            <DropdownItem>{t('Delete')} <i className="ri-delete-bin-line float-end text-muted"></i></DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </ul>
                            </div> */}
                        </li>
                    )
                }

                {/* {isOpen && (
                    <Lightbox
                        mainSrc={currentImage}
                        onCloseRequest={toggleLightbox}
                        imageTitle="Project 1"
                    />
                )} */}

            </ul>
        </React.Fragment>
    )
}

export default ImageList